import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/timeout';

import { AuthRefreshService } from '../../service/auth-refresh/auth-refresh.service';
import { environment } from '../../../environments/environment';

let serviceCode = '';
serviceCode = environment.serviceCode;

@Injectable()
export class HttpService {

  constructor(
    private http: Http,
    private refresh: AuthRefreshService,
  ) { }

  get(url: string, query?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._get(url, query)
      .then(resolve)
      .catch(error => {
        if (error.name === 'TimeoutError') {
          reject(new Error('通信できませんでした。再実行してください。'));
        } else if (error.status === 0) {
          reject(new Error('サーバへ接続できませんでした。'));
        } else {
          reject(error);
        }
      });
    });
  }

  // Use this to disable the json map
  getNoMap(url: string, query?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._getNoMap(url, query)
      .then(resolve)
      .catch(error => {
        if (error.name === 'TimeoutError') {
          reject(new Error('通信できませんでした。再実行してください。'));
        } else if (error.status === 0) {
          reject(new Error('サーバへ接続できませんでした。'));
        } else {
          reject(error);
        }
      });
    });
  }

  post(url: string, jsonInput: any, header?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._post(url, jsonInput, header)
      .then(resolve)
      .catch(error => {
        if (error.name === 'TimeoutError') {
          reject(new Error('通信できませんでした。再実行してください。'));
        } else if (error.status === 0) {
          reject(new Error('サーバへ接続できませんでした。'));
        } else {
          reject(error);
        }
      });
    });
  }

  put(url: string, jsonInput: object, targetServiceCode?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this._put(url, jsonInput, targetServiceCode)
      .then(resolve)
      .catch(error => {
        if (error.name === 'TimeoutError') {
          reject(new Error('通信できませんでした。再実行してください。'));
        } else if (error.status === 0) {
          reject(new Error('サーバへ接続できませんでした。'));
        } else {
          reject(error);
        }
      });
    });
  }

  delete(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this._delete(url)
      .then(resolve)
      .catch(error => {
        if (error.name === 'TimeoutError') {
          reject(new Error('通信できませんでした。再実行してください。'));
        } else if (error.status === 0) {
          reject(new Error('サーバへ接続できませんでした。'));
        } else {
          reject(error);
        }
      });
    });
  }

  private _get(url: string, query?: any): Promise<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-service-code': serviceCode,
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    });

    const requestOptions = new RequestOptions();
    requestOptions.headers = headers;

    if (query !== undefined) {
      requestOptions.params = query;
    }

    return this.http
      .get(url, requestOptions)
      // .timeout(5000)
      .map(response => response.json() as any)
      .toPromise();
  }

  // Use this to dable the Json map
  private _getNoMap(url: string, query?: any): Promise<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-service-code': serviceCode,
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    });

    const requestOptions = new RequestOptions();
    requestOptions.headers = headers;

    if (query !== undefined) {
      requestOptions.params = query;
    }

    return this.http
      .get(url, requestOptions)
      // .timeout(5000)
      .toPromise();
  }

  private _post(url: string, jsonInput: any, header?: any): Promise<any> {
    header = header || {
      'Content-Type': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-service-code': serviceCode,
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    const headers = new Headers(header);
    let body = JSON.stringify(jsonInput);
    if (!body) {
      body = jsonInput;
    }
    return this.http
    .post(url, jsonInput, {headers: headers})
    // .timeout(5000)
    .map(response => response.json() as any)
    .toPromise();
  }

  // SW-2055 : 本来、targetServiceCodeを引数としたくないが、届先修正APIがAAS版で動かないため、強制的に標準版として動作させたく、引数を追加する。
  private _put(url: string, jsonInput: object, targetServiceCode?: string): Promise<any> {
    if (targetServiceCode === undefined) {
      targetServiceCode = serviceCode;
    }
    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-service-code': targetServiceCode,
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    });
    return this.http
    .put(url, JSON.stringify(jsonInput), {headers: headers})
    // .timeout(5000)
    .map(response => response.json() as any)
    .toPromise();
  }

  private _delete(url): Promise<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-service-code': serviceCode,
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    });
    return this.http
    .delete(url, { headers: headers })
    // .timeout(5000)
    .map(response => response.json() as any)
    .toPromise();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/http/http.service.ts